import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Ordinal"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M19.5 19.5V3H13.5V7.5H9V12H4.5V19.5H1.5V21H22.5V19.5H19.5ZM6 19.5V13.5H9V19.5H6ZM10.5 19.5V9H13.5V19.5H10.5ZM15 19.5V4.5H18V19.5H15Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Ordinal.vue"]]);
